import React from 'react'
import { SerializedStyles, css } from '@emotion/core'
import { Trans } from 'react-i18next'

type Props<T = string> = {
  tabs: Array<{ name: string; value: T }>
  currentTab: T
  onChange: (tab: T) => void
  customTabStyle?: SerializedStyles
  customActiveTabStyle?: SerializedStyles
  customInactiveTabStyle?: SerializedStyles
  customContainerStyle?: SerializedStyles
}

export const StateToggleTab = <T,>(props: React.PropsWithChildren<Props<T>>) => {
  return (
    <div css={[settingTabContainerStyle, props.customContainerStyle]}>
      {props.tabs.map(tab => (
        <div
          key={String(tab.value)}
          css={[
            props.currentTab === tab.value ? settingTabActiveStyle : settingTabStyle,
            props.customTabStyle,
            props.currentTab === tab.value ? props.customActiveTabStyle : props.customInactiveTabStyle,
          ]}
          onClick={() => props.onChange(tab.value)}
        >
          <Trans i18nKey={tab.name as string} />
        </div>
      ))}
    </div>
  )
}
const centerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  wordBreak: 'keep-all',
  overflowWrap: 'break-word',
  textAlign: 'center',
})

const settingTabContainerStyle = css({
  height: 45,
  display: 'flex',
})

const settingTabStyle = css(centerStyle, {
  width: 134,
  height: 45,
  borderRadius: '5px 5px 0 0',
  background: '#F5F5F5',
  boxShadow: '0px 0px 6px #0000001A',
  fontSize: 14,
  fontWeight: 'bold',
  color: '#676767',
  '&:hover': {
    cursor: 'pointer',
    opacity: 0.8,
  },
})

const settingTabActiveStyle = css(centerStyle, {
  width: 134,
  height: 41,
  borderRadius: '5px 5px 0 0',
  background: '#fff',
  boxShadow: '0px 0px 6px #0000001A',
  position: 'relative',
  fontSize: 14,
  fontWeight: 'bold',
  color: '#F2A40B',
  '&::after': {
    position: 'absolute',
    bottom: -4,
    left: 0,
    height: 6,
    width: '100%',
    content: '""',
    background: '#fff',
    zIndex: 3,
  },
})
